import { ReactElement, Suspense, lazy } from 'react';
import { Navigate as Redirect, Route, Routes } from 'react-router-dom';
import { DashboardPath } from './routes';

const Home = lazy(() => import('./pages/Home/Home'));

export const DashboardRoutes: React.FC = (): ReactElement => {
  return (
    <Suspense>
      <Routes>
        <Route path={DashboardPath.Home} element={<Home />} />
        <Route path="*" element={<Redirect to={DashboardPath.Home} replace />} />
      </Routes>
    </Suspense>
  );
};

export const DashboardRouter: React.FC = () => <DashboardRoutes />;
